import { Directive, ElementRef, OnDestroy, inject } from "@angular/core";

@Directive({ selector: "[preventNavIfSelected]" })
/** Prevents navigation if the element has the "selected" class, so we don"t reset the route */
export class PreventNavIfSelectedDirective implements OnDestroy {
	private el = inject(ElementRef);

	private clickHandler = (event: Event) => {
		const native = this.el.nativeElement as HTMLElement;
		if (native && native.classList && native.classList.contains("selected")) {
			event.preventDefault();
			event.stopImmediatePropagation();
		}
	};

	constructor() {
		const native = this.el.nativeElement as HTMLElement;
		if (native && native.addEventListener) {
			native.addEventListener("click", this.clickHandler, true);
		}
	}

	ngOnDestroy(): void {
		const native = this.el.nativeElement as HTMLElement;
		if (native && native.removeEventListener) {
			native.removeEventListener("click", this.clickHandler, true);
		}
	}
}
